
<template>
  <div class="select-data-preview-header" v-if="props.hasEdit">
    <div class="select-data-preview-header__title">{{ $t('Your search') }}</div>
    <div class="select-data-preview-header__edit">
      <button class="color-blue" @click="emit('edit')">{{$t('Edit')}}</button>
    </div>
  </div>
  <div class="selected-data-preview"  @click="emit('edit')">
    <div class="selected-data-preview__col">
      <div class="title">{{$t('Check-In')}}</div>
      <div class="value"> {{searchStore.formattedDates[0] || '-'}}</div>
    </div>
    <div class="vr"></div>
    <div class="selected-data-preview__col">
      <div class="title">{{$t('Check-Out')}}</div>
      <div class="value">{{searchStore.formattedDates[1] || '-'}}</div>
    </div>
    <div class="vr"></div>
    <div class="selected-data-preview__col">
      <div class="title">{{$t('Travelers')}}</div>
      <div class="value">{{searchStore.getTotalVisitors}} {{(searchStore.getTotalVisitors !== 1) ? $t('Travelers') : $t('Traveler')}}</div>
    </div>
  </div>
</template>

<script setup lang="ts">
import {useSearchStore} from '~/store/search'
const props = defineProps({
  hasEdit: {type: Boolean, default: false},
})

const emit = defineEmits(['edit'])

const searchStore = useSearchStore()

</script>

<style scoped lang="scss">
.select-data-preview-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 12px;

  &__title {
    font-size: 16px;
    font-weight: 500;
  }

  &__edit {
    font-size: 16px;
    color: var(--blue);
    padding-right: 10px;
  }

}

.selected-data-preview {
  margin: 12px 0 24px 0;
  display: flex;
  gap: 24px;
  justify-content: space-between;

  .vr {
    height: auto;
    width: 1px;
    background: var(--grey);
  }

  &__col {

    .title {
      color: var(--dark-grey);
      font-size: 12px;
      line-height: 133.333%;
    }

    .value {
      white-space: nowrap;
    }

  }
}

</style>
